import { isPlatformBrowser, NgOptimizedImage } from "@angular/common";
import { AfterViewInit, Component, ElementRef, inject, input, OnDestroy, PLATFORM_ID, ViewChild } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { SvgIconComponent } from "angular-svg-icon";
import EmblaCarousel, { EmblaCarouselType } from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { PathFromItemPipe } from "../../../../../../common/pipes/path-from-item.pipe";
import { ItemsSuppliers } from "../../../../../api/packbo/models/items-suppliers";

@Component({
    selector: "packbo-supplier-carousel",
    templateUrl: "./supplier-carousel.template.html",
    imports: [GetDirectusImagePipe, SvgIconComponent, PathFromItemPipe, NgOptimizedImage, TranslocoPipe]
})
export class SupplierCarouselComponent implements AfterViewInit, OnDestroy {
    @ViewChild("emblaViewport", { static: false }) emblaViewport!: ElementRef<HTMLElement>;

    public readonly suppliers = input.required<ItemsSuppliers[]>();

    private emblaCarouselType?: EmblaCarouselType;
    private readonly platformId = inject(PLATFORM_ID);

    public ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId) && this.emblaViewport && this.emblaViewport.nativeElement) {
            this.emblaCarouselType = EmblaCarousel(
                this.emblaViewport.nativeElement,
                {
                    loop: true,
                    align: "start"
                },
                [
                    Autoplay({
                        delay: 5000,
                        stopOnInteraction: false,
                        stopOnMouseEnter: false,
                        stopOnFocusIn: false
                    })
                ]
            );
        }
    }

    public ngOnDestroy(): void {
        if (this.emblaCarouselType) {
            this.emblaCarouselType.destroy();
        }
    }

    public scrollPrev(): void {
        this.emblaCarouselType?.scrollPrev();
    }

    public scrollNext(): void {
        this.emblaCarouselType?.scrollNext();
    }
}
